import { useUnSignContract } from '@/components/shared/components/ConditionsSummary/LoanConditionsSummary/components/LenderApplications/components/LoanApplicationActionDialog/hooks/useUnSignContract';
import { StandardActionDialog } from '@/components/shared/components/StandardActionDialog/StandardActionDialog';
import { Text } from '@/components/shared/components/Text';

interface UnSignContractActionDialogProps {
  loanId: string;
  loanApplicationId: string;
  setLoanApplicationAction: (e) => void;
  useDialogProps: {
    opened: boolean;
    setOpened: (boolean) => void;
  };
}

export const UnSignContractActionDialog = ({
  loanId,
  loanApplicationId,
  setLoanApplicationAction,
  useDialogProps,
}: UnSignContractActionDialogProps) => {
  const { loading, unSignLoanLenderBorrowerContract } = useUnSignContract({
    loanId,
    loanApplicationId,
  });

  const { opened, setOpened } = useDialogProps;

  return (
    <StandardActionDialog
      opened={opened}
      setOpened={setOpened}
      titleTextElement={<Text tId={'UN_SIGN_LOAN_LENDER_BORROWER_CONTRACT'} />}
      actionDescriptionTextElement={<Text tId={'UN_SIGN_LOAN_LENDER_BORROWER_CONTRACT_DESCRIPTION'} />}
      actionButtonsArray={[
        {
          onClick: async () => {
            await unSignLoanLenderBorrowerContract();
            setOpened(false);
          },
          buttonLabelTextId: 'UN_SIGN',
        },
      ]}
      setActionDialogParams={setLoanApplicationAction}
      loading={loading}
    />
  );
};
